__turbopack_context__.v({
  "button": "_7wLLQW_button",
});
